import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import Fab from '@material-ui/core/Fab'
import Icon from '@material-ui/core/Icon'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableFooter from '@material-ui/core/TableFooter'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'

import { showHtmlAlert } from './alert'
import getString, { target } from '../config/strings'

import moment from 'moment'
import 'moment/locale/de'
import 'moment/locale/en-gb'

const styles = theme => ({
  button: {
    margin: theme.spacing(1)
  }
})

class TariffsTable extends PureComponent {

  constructor (props, context, updater) {
    super(props, context, updater)
    this.state = {
      page: 0,
      rowsPerPage: 10,
    }
  }

  static shortenDescription (description, maxLength) {
    let tmp = document.createElement('DIV')
    tmp.innerHTML = description
    let text = tmp.textContent || tmp.innerText || ''
    return (text.length > maxLength) ? (text.substring(0, maxLength - 4) + ' ...') : text
  }

  handleChangePage = (event, page) => {
    this.setState({page: page})
  }

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value})
  }

  askDelete (index) {
    let self = this
    showHtmlAlert(getString('TARIFF_DELETE_TEXT', [this.props.tariffs[index].name]),
      getString('TARIFF_DELETE'),
      [{label: getString('YES'), callback: () => {self.props.deleteFunc(index)}},
        {label: getString('NO')}])
  }

  render () {
    let self = this
    const {classes} = self.props
    const {page, rowsPerPage} = self.state
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, self.props.tariffs.length - page * rowsPerPage)

    if (self.props.tariffs.length === 0) {
      if ( self.props.isFiltered) {
        return (<p>{getString('NO_FILTERED_TARIFFS')}</p>)
      } else {
        return (<p>{getString('NO_TARIFFS')}</p>)
      }
    }

    const momentLocaleString = target.choosenLanguage === 'en' ? 'en-gb' : target.choosenLanguage

    return (
      <Table className="tariffs-table" cellSpacing="0" align="center">
        <TableHead>
          <TableRow>
            <TableCell>&nbsp;</TableCell>
            <TableCell>{getString('TARIFF_NAME')}</TableCell>
            <TableCell>{getString('TARIFF_DESCRIPTION')}</TableCell>
            <TableCell>{getString('TARIFF_VISIBLE_FROM')}</TableCell>
            <TableCell>&nbsp;</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {self.props.tariffs.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (tariff, index) {
            return (<TableRow key={index}>
              <TableCell><Fab color="primary" aria-label="edit" className={classes.button} size={'small'}
                                 onClick={() => {self.props.editFunc((page * rowsPerPage)+index)}}>
                <Icon>edit_icon</Icon>
              </Fab>
              </TableCell>
              <TableCell>{tariff.name}</TableCell>
              <TableCell>{TariffsTable.shortenDescription(tariff.description, 60)}</TableCell>
              <TableCell>{moment(new Date(tariff.visible_from)).locale(momentLocaleString).format('L LT')}</TableCell>
              <TableCell>
                <Fab color="secondary" aria-label="delete" className={classes.button} size={'small'}
                        onClick={() => {self.askDelete((page * rowsPerPage)+index)}}>
                  <DeleteIcon/>
                </Fab>
              </TableCell>
            </TableRow>)
          })}
          {emptyRows > 0 && (
            <TableRow style={{height: 76 * emptyRows}}>
              <TableCell colSpan={5}/>
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={5}
              count={self.props.tariffs.length}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    )
  }
}

TariffsTable.propTypes = {
  classes: PropTypes.object.isRequired,
  isFiltered: PropTypes.bool,
  editFunc: PropTypes.func.isRequired,
  deleteFunc: PropTypes.func.isRequired,
  tariffs: PropTypes.array.isRequired
}

export default withStyles(styles)(TariffsTable)
